// 表单字段配置
export const formFieldConfigs = {
    // 位置选择
    positionSelect: {
        type: 'select',
        label: '展示位置',
        placeholder: '请选择位置',
        modelKey: 'class_id',
        clearable: true,
        options: '',
        events: [{
            type: 'change',
            function: 'update:params',
        }]
    },

    // 状态选择
    statusSelect: {
        type: 'select',
        label: '状态',
        placeholder: '请选择',
        modelKey: 'status',
        clearable: true,
        options: null,
        events: [{
            type: 'change',
            function: 'update:params',
        }]
    },

    // platform是pc还是wap选择
    platformSelect: {
        type: 'select',
        label: '平台',
        placeholder: '请选择',
        modelKey: 'platform',
        clearable: true,
        options: [{
            name: 'PC',
            id: 1
        }, {
            name: 'WAP',
            id: 2
        }],
        events: [{
            type: 'change',
            function: 'update:params',
        }]
    },

    // 关键字搜索
    keywordSearch: {
        type: 'input',
        label: '关键字',
        placeholder: '请输入关键字',
        modelKey: 'key',
        clearable: true,
        events: [{
            type: 'input',
            function: 'update:params',
        }],
        nativeEvents: [{
            type: 'keyup',
            function: 'search',
        }],
    },

    // 操作按钮
    actionButtons: {
        type: 'actions',
        buttons: [{
            key: 'search',
            type: 'primary',
            round: true,
            text: '查询',
            events: [{
                type: 'click',
                function: 'search',
            }],
        }, {
            key: 'add',
            type: 'primary',
            round: true,
            text: '添加',
            events: [{
                type: 'click',
                function: 'createModel',
            }],
        }]
    },
};
